import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import GallerySection from "@/components/GallerySection";
import ReviewsSection from "@/components/ReviewsSection";
import BookingSection from "@/components/BookingSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import AdminDashboard from "@/components/AdminDashboard";
import PortfolioPage from "@/components/PortfolioPage";
import PromoBanner from "@/components/PromoBanner";
import BeforeAfterSection from "@/components/BeforeAfterSection";
import LocalExpertiseSection from "@/components/LocalExpertiseSection";
import ServiceAreasSection from "@/components/ServiceAreasSection";
import WalkInPage from "@/components/WalkInPage";
import BusinessCardPage from "@/components/BusinessCardPage";
import FlyersPage from "@/components/FlyersPage";
import ConsentPolicyPage from "@/components/ConsentPolicyPage";
import WaitlistPage from "@/components/WaitlistPage";
import StyleFinderPage from "@/components/StyleFinderPage";
import BohoLandingPage from "@/components/BohoLandingPage";
import PricingCalculatorPage from "@/components/PricingCalculatorPage";
import WindowStickerPage from "@/components/WindowStickerPage";
import GoogleSEOPage from "@/components/GoogleSEOPage";
import ShopPage from "@/components/ShopPage";
import ChatWidget from "@/components/ChatWidget";
import WednesdayBanner from "@/components/WednesdayBanner";
import PageViewTracker from "@/components/PageViewTracker";
import { Toaster } from "sonner";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-brand-bg" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <PromoBanner />
        <AboutSection />
        <ServicesSection />
        <GallerySection />
        <BeforeAfterSection />
        <ReviewsSection />
        <BookingSection />
        <ContactSection />
      </main>
      <ServiceAreasSection />
      <LocalExpertiseSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <WednesdayBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/walkin" element={<WalkInPage />} />
        <Route path="/business-card" element={<BusinessCardPage />} />
        <Route path="/flyers" element={<FlyersPage />} />
        <Route path="/consent-policy" element={<ConsentPolicyPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/style-finder" element={<StyleFinderPage />} />
        <Route path="/boho-braids" element={<BohoLandingPage />} />
        <Route path="/pricing" element={<PricingCalculatorPage />} />
        <Route path="/window-sticker" element={<WindowStickerPage />} />
        <Route path="/google-ranking" element={<GoogleSEOPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <ChatWidget />
      <Toaster position="bottom-right" richColors theme="dark" />
    </BrowserRouter>
  );
}

export default App;
